module.exports = __webpack_public_path__ + "img/arrow-square-left.7e938595.svg";